import React from 'react';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { Domingo } from '@fiverr-private/domingo';
import { Icon } from '@fiverr-private/fit';
import { ArrowLeftIcon } from '@fiverr-private/icons';
import { getBQData, getMPData } from '../../utils/business/bi-utils';
import Link from '../Links/Link';

import styles from './style.module.scss';

const ExitBusinessDomainLink = () => {
    const { url } = getContext();
    const basedUrl = Domingo(url).removePro().removePath().url;

    return (
        <Link
            className={styles.link}
            href={`${basedUrl}?source=header_business_navigation`}
            bigQueryData={getBQData({ type: 'go_to_fiverr' })}
            mpData={getMPData({ eventName: 'Clicked Fiverr Business visitor header', target: 'go_to_fiverr' })}
        >
            <Icon className={styles.icon} size={20}>
                <ArrowLeftIcon />
            </Icon>
            <span>
                <I18n k="header.business_visitor.go_to_fiverr" />
            </span>
        </Link>
    );
};

export default ExitBusinessDomainLink;
